import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST, FetchspotContactOppMapOppMapFailure, FetchspotContactOppMapOppMapSuccess, FetchSpotContactsOppMapFailure, FetchSpotContactsOppMapSuccess } from "../../actions/targetedReachout/spotContactOppMapActions";
import iq_api_v2 from "../../../../services/iqApiV2";



async function spotContactOppMap(opportunityIds,userId) {

    
    const formData = new FormData();
    formData.append("opportunity_ids", opportunityIds?.flat().join(","));
    formData.append("user_id", userId);
  
    try {
      const response = await iq_api_v2.post(
        '/spot_contacts/opportunities_summary',
        formData, // send as form data
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response?.data?.result;
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      throw error;
    }
  }


// Worker Saga
function* fetchspotContactOppMapSaga() {
  try {
    const payload = yield select(
      (state) => state?.spotContactOppMapReducer?.payload
    );
    const { opportunityIds,userId } = payload;
    const data = yield call(
        spotContactOppMap,
        opportunityIds,
        userId
    );
    yield put(FetchSpotContactsOppMapSuccess(data));
  } catch (error) {
    yield put(FetchSpotContactsOppMapFailure(error.message));
  }
}

// Watcher Saga
export function* watchspotContactOppMapSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_OPP_MAP_REQUEST, fetchspotContactOppMapSaga);

}
